import { useDispatch } from 'react-redux'
import shareDataElementActions from '@/redux/actions/shareDataElement'

const useShareDataElement = () => {
	const dispatch = useDispatch()

	const handleDataElement = (dataElement) => {
		dispatch(shareDataElementActions.dataElementAction(dataElement))
	}

	const handleRecipient = (recipient) => {
		dispatch(shareDataElementActions.recipientAction(recipient))
	}

	const handleOnBehalfOf = (onBehalfOf) => {
		dispatch(shareDataElementActions.onBehalfOfAction(onBehalfOf))
	}

	const handleStoreFor = (storeFor) => {
		dispatch(shareDataElementActions.storeForAction(storeFor))
	}

	const handleReferenceID = (referenceID) => {
		dispatch(shareDataElementActions.referenceIdAction(referenceID))
	}

	const handleAction = (action) => {
		dispatch(shareDataElementActions.actionAction(action))
	}

	const handlePayload = (payload) => {
		dispatch(shareDataElementActions.payloadAction(payload))
	}

	const handleAttachment = (attachment) => {
		dispatch(shareDataElementActions.attachmentsAction(attachment))
	}

	const handleRequiredAttachments = (attachments) => {
		dispatch(shareDataElementActions.requiredAttachmentsAction(attachments))
	}

	const handleStatus = (status) => {
		dispatch(shareDataElementActions.statusAction(status))
	}

	const handleParticipantList = (participant) => {
		dispatch(shareDataElementActions.participantsListAction(participant))
	}

	const handlestoreForList = (storeFor) => {
		dispatch(shareDataElementActions.storeForListAction(storeFor))
	}

	const handleOnBehalfOfList = (onBehalfOf) => {
		dispatch(shareDataElementActions.onBehalfOfListAction(onBehalfOf))
	}

	const handleUpdateState = (data) => {
		dispatch(shareDataElementActions.updateStateAction(data))
	}

	const handlePrincipalsList = (principalsList) => {
    	dispatch(shareDataElementActions.principalsListAction(principalsList))
	}

	const handleSelectedPrincipals = (selectedPrincipals) => {
		dispatch(shareDataElementActions.selectedPrincipalsAction(selectedPrincipals))
	}

	const handleTransactionType = (transactionType) => {
		dispatch(shareDataElementActions.transactionTypeAction(transactionType))
	}

	const handleMasterData = (masterData) => {
		dispatch(shareDataElementActions.masterDataAction(masterData))
	}

	const handleConsumerMasterData = (consumerMasterData) => {
		dispatch(shareDataElementActions.consumerMasterDataAction(consumerMasterData))
	}

	const handleSelectedVersion = (selectedVersion) => {
		dispatch(shareDataElementActions.selectedVersionAction(selectedVersion))
	}

	const handleReset = () => {
		dispatch(shareDataElementActions.resetAction())
	}

	return {
		handleDataElement,
		handleRecipient,
		handleOnBehalfOf,
		handleStoreFor,
		handleReferenceID,
		handleAction,
		handlePayload,
		handleAttachment,
		handleRequiredAttachments,
		handleStatus,
		handleParticipantList,
		handlestoreForList,
		handleOnBehalfOfList,
		handleUpdateState,
		handlePrincipalsList,
		handleSelectedPrincipals,
		handleTransactionType,
		handleMasterData,
		handleConsumerMasterData,
		handleSelectedVersion,
		handleReset
	}
}

export default useShareDataElement
